<template>
  <div class="home">
    <Layout>
      <template slot="title">
        <sm-heading size="2">Búsqueda de prospectos</sm-heading>
      </template>
      <Instructions v-if="isZeroStep"></Instructions>
      <Steps v-if="isFirstToFourthStep"></Steps>
    </Layout>
  </div>
</template>

<script>
// @ is an alias to /src
import Layout from '@/components/Layout'
import Instructions from '@/components/Instructions'
import Steps from '@/components/Steps'

export default {
  name: 'Home',
  components: {
    Layout,
    Instructions,
    Steps
  },
  computed: {
    isZeroStep () {
      return this.$store.getters.isZeroStep
    },
    isThirdStep () {
      return this.$store.getters.isThirdStep
    },
    isFourthStep () {
      return this.$store.getters.isFourthStep
    },
    isFirstToFourthStep () {
      return this.$store.getters.isFirstToFourthStep
    }
  }
}
</script>

<style>
</style>
